import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=94511204&lang=pug&"
import script from "./LinkIcon.vue?vue&type=script&lang=ts&"
export * from "./LinkIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=94511204&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports